{
  "version": 1,
  "sdk": {
    "name": "prospix-js",
    "version": "1.0.0"
  },
  "siteKey": "",
  "apiBase": "",
  "debug": false,
  "consentMode": "opt-in",
  "platform": {
    "mode": "first_party",
    "addons": {
      "enabled": []
    }
  },
  "queue": {
    "flushIntervalMs": 2000,
    "maxEvents": 100,
    "maxBytes": 262144,
    "ttlMs": 86400000
  },
  "privacy": {
    "defaultConsent": "unknown",
    "respectGpc": true,
    "respectDnt": true,
    "gpcDefault": "denied",
    "consentUi": {
      "mode": "auto",
      "privacyUrl": "",
      "showPreferencesButton": true
    },
    "regionPriority": ["QC", "CA", "US", "EU", "UK", "ROW"],
    "region": "CA",
    "regionConsentModes": {
      "CA": "opt-in",
      "US": "opt-in",
      "EU": "opt-in",
      "UK": "opt-in",
      "ROW": "opt-in",
      "QC": "opt-in"
    },
    "dataCategories": {
      "context_page": "consented",
      "context_device": "consented",
      "marketing_params": "consented",
      "network_hints": "consented",
      "behavioral_events": "consented",
      "form_analytics": "consented",
      "commerce_analytics": "consented",
      "video_analytics": "consented",
      "performance_analytics": "consented",
      "error_telemetry": "consented",
      "bot_signals": "always",
      "attribution": "consented",
      "outbound_clicks": "consented",
      "session_quality": "consented",
      "search_intent": "consented",
      "impression_analytics": "consented",
      "frustration_signals": "consented",
      "experiment_exposure": "consented",
      "identity_linkage": "consented",
      "identity_resolution": "consented",
      "audience_decisioning": "consented",
      "heatmap": "consented",
      "replay": "consented",
      "adblock_signals": "consented",
      "geo_enrichment": "consented",
      "third_party_destinations": "consented",
      "consent_analytics": "always"
    },
    "regionDataCategories": {
      "EU": {
        "geo_enrichment": "off",
        "adblock_signals": "off",
        "replay": "off"
      },
      "UK": {
        "geo_enrichment": "off",
        "adblock_signals": "off",
        "replay": "off"
      },
      "QC": {
        "geo_enrichment": "off",
        "adblock_signals": "off",
        "replay": "off"
      },
      "ROW": {
        "replay": "off"
      }
    },
    "marketingPlugins": [
      "attribution",
      "outbound",
      "shopify",
      "firstparty",
      "search",
      "identitylink",
      "identitystorage",
      "intent",
      "journey",
      "destinations"
    ],
    "allowedQueryParams": [],
    "identifyAllowlist": ["user_id", "account_id", "plan", "role"],
    "redactKeys": [
      "password",
      "pass",
      "pwd",
      "credit",
      "card",
      "email",
      "phone",
      "ssn",
      "social",
      "token"
    ]
  },
  "identityCapture": {
    "enabled": true,
    "automaticSources": false,
    "markedForms": true,
    "endpointPath": "/pxl/identity",
    "purposes": ["identity_resolution", "enrichment"],
    "discovery": {
      "cookieNames": [],
      "localStorageKeys": [],
      "sessionStorageKeys": [],
      "indexedDb": [],
      "cacheStorage": [],
      "maxCandidates": 10
    }
  },
  "plugins": {
    "disabled": [],
    "enabled": [],
    "tiers": {
      "essential": ["consent", "gcm", "diagnostics", "presence", "bot"],
      "early": [
        "router",
        "click",
        "perf",
        "adblock",
        "session_quality",
        "experiments",
        "identitylink",
        "intent",
        "journey",
        "errors",
        "webvitals",
        "outbound",
        "attribution",
        "firstparty"
      ],
      "late": [
        "engagement",
        "scroll",
        "download",
        "forms",
        "ecommerce",
        "video",
        "search",
        "impressions",
        "shopify",
        "ratelimit"
      ],
      "idle": ["heatmap", "replay", "identitystorage", "destinations"]
    },
    "sampling": {
      "rate": 1
    }
  },
  "destinations": {
    "enabled": [],
    "config": {},
    "eventMaps": {
      "meta": {
        "page_view": "PageView",
        "signup": "CompleteRegistration",
        "lead": "Lead",
        "purchase": "Purchase",
        "trial_start": "StartTrial",
        "subscription_start": "Subscribe",
        "subscription_cancel": "CancelSubscription",
        "checkout_started": "InitiateCheckout",
        "add_payment_info": "AddPaymentInfo",
        "contact_sales": "Contact",
        "demo_requested": "DemoRequested",
        "demo_scheduled": "DemoScheduled",
        "cta_click": "CTA",
        "search": "Search",
        "content_view": "ViewContent"
      },
      "google": {
        "page_view": "page_view",
        "signup": "sign_up",
        "lead": "generate_lead",
        "purchase": "purchase",
        "trial_start": "start_trial",
        "subscription_start": "subscribe",
        "subscription_cancel": "cancel_subscription",
        "checkout_started": "begin_checkout",
        "add_payment_info": "add_payment_info",
        "contact_sales": "contact_sales",
        "demo_requested": "demo_requested",
        "demo_scheduled": "demo_scheduled",
        "cta_click": "cta_click",
        "search": "search",
        "content_view": "view_item"
      },
      "tiktok": {
        "page_view": "PageView",
        "signup": "CompleteRegistration",
        "lead": "SubmitForm",
        "purchase": "Purchase",
        "trial_start": "StartTrial",
        "subscription_start": "Subscribe",
        "subscription_cancel": "Unsubscribe",
        "checkout_started": "InitiateCheckout",
        "add_payment_info": "AddPaymentInfo",
        "contact_sales": "Contact",
        "demo_requested": "DemoRequested",
        "demo_scheduled": "DemoScheduled",
        "cta_click": "CTA",
        "search": "Search",
        "content_view": "ViewContent"
      },
      "linkedin": {
        "page_view": "page_view",
        "signup": "signup",
        "lead": "lead",
        "purchase": "purchase",
        "trial_start": "trial_start",
        "subscription_start": "subscription_start",
        "subscription_cancel": "subscription_cancel",
        "checkout_started": "checkout_started",
        "add_payment_info": "add_payment_info",
        "contact_sales": "contact_sales",
        "demo_requested": "demo_requested",
        "demo_scheduled": "demo_scheduled",
        "cta_click": "cta_click",
        "search": "search",
        "content_view": "content_view"
      },
      "microsoft": {
        "page_view": "page_view",
        "signup": "signup",
        "lead": "lead",
        "purchase": "purchase",
        "trial_start": "trial_start",
        "subscription_start": "subscription_start",
        "subscription_cancel": "subscription_cancel",
        "checkout_started": "checkout_started",
        "add_payment_info": "add_payment_info",
        "contact_sales": "contact_sales",
        "demo_requested": "demo_requested",
        "demo_scheduled": "demo_scheduled",
        "cta_click": "cta_click",
        "search": "search",
        "content_view": "content_view"
      },
      "pinterest": {
        "page_view": "pagevisit",
        "signup": "signup",
        "lead": "lead",
        "purchase": "purchase",
        "trial_start": "starttrial",
        "subscription_start": "subscribe",
        "subscription_cancel": "unsubscribe",
        "checkout_started": "checkout",
        "add_payment_info": "add_payment_info",
        "contact_sales": "contact_sales",
        "demo_requested": "demo_requested",
        "demo_scheduled": "demo_scheduled",
        "cta_click": "cta_click",
        "search": "search",
        "content_view": "viewcontent"
      },
      "snap": {
        "page_view": "PAGE_VIEW",
        "signup": "SIGN_UP",
        "lead": "LEAD",
        "purchase": "PURCHASE",
        "trial_start": "START_TRIAL",
        "subscription_start": "SUBSCRIBE",
        "subscription_cancel": "UNSUBSCRIBE",
        "checkout_started": "START_CHECKOUT",
        "add_payment_info": "ADD_PAYMENT_INFO",
        "contact_sales": "CONTACT",
        "demo_requested": "DEMO_REQUESTED",
        "demo_scheduled": "DEMO_SCHEDULED",
        "cta_click": "CTA_CLICK",
        "search": "SEARCH",
        "content_view": "VIEW_CONTENT"
      },
      "x": {
        "page_view": "PageView",
        "signup": "SignUp",
        "lead": "Lead",
        "purchase": "Purchase",
        "trial_start": "StartTrial",
        "subscription_start": "Subscribe",
        "subscription_cancel": "Unsubscribe",
        "checkout_started": "StartCheckout",
        "add_payment_info": "AddPaymentInfo",
        "contact_sales": "ContactSales",
        "demo_requested": "DemoRequested",
        "demo_scheduled": "DemoScheduled",
        "cta_click": "CTA",
        "search": "Search",
        "content_view": "ViewContent"
      },
      "reddit": {
        "page_view": "PageVisit",
        "signup": "SignUp",
        "lead": "Lead",
        "purchase": "Purchase",
        "trial_start": "StartTrial",
        "subscription_start": "Subscribe",
        "subscription_cancel": "Unsubscribe",
        "checkout_started": "InitiateCheckout",
        "add_payment_info": "AddPaymentInfo",
        "contact_sales": "ContactSales",
        "demo_requested": "DemoRequested",
        "demo_scheduled": "DemoScheduled",
        "cta_click": "CTA",
        "search": "Search",
        "content_view": "ViewContent"
      },
      "amazon": {}
    }
  },
  "engagement": {
    "heartbeatMs": 15000
  },
  "scroll": {
    "milestones": [25, 50, 75, 90]
  },
  "heatmap": {
    "clickSampleRate": 0.1,
    "scrollSampleRate": 0.05,
    "scrollThrottleMs": 250
  },
  "video": {
    "progressMilestones": [25, 50, 75]
  },
  "replay": {
    "enabled": false,
    "chunkIntervalMs": 2000,
    "maxChunkBytes": 48000
  },
  "errors": {
    "maxPerMinute": 5
  },
  "intelligence": {
    "intent": {
      "enabled": true,
      "modelVersion": "intent-v1",
      "windowMs": 604800000,
      "emitMinIntervalMs": 30000,
      "decayPerHour": 1,
      "warmThreshold": 25,
      "hotThreshold": 60,
      "maxReasons": 5,
      "weights": {
        "page_view": 1,
        "return_visit": 10,
        "content_view": 6,
        "view_item": 8,
        "search": 6,
        "cta_click": 8,
        "form_start": 4,
        "form_submit": 25,
        "add_to_cart": 20,
        "begin_checkout": 30,
        "checkout_started": 30,
        "purchase": 100
      }
    },
    "journey": {
      "enabled": true,
      "modelVersion": "journey-v1",
      "abandonmentAfterMs": 1800000
    }
  }
}
